"use strict";

exports.__esModule = true;
exports.ChartTitleSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
var _Form = require("../../Form");
var _styledComponents = require("styled-components");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChartTitleSelector = exports.ChartTitleSelector = function ChartTitleSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var elementEditor = props.elementEditor,
    path = props.path,
    title = props.title;
  var defaultColor = theme.TextColor || "#000000";
  var defaultVerticalPosition = "left";
  var defaultHorizontalPosition = "top";
  var defaultMainFontSize = 18;
  var defaultSubFontSize = 12;
  var defaultMainText = "";
  var defaultSubText = "";
  (0, _react.useEffect)(function () {
    if (!title || Object.entries(title).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title",
          value: el.props.title = {
            show: false,
            mainFontSize: defaultMainFontSize,
            subFontSize: defaultSubFontSize,
            verticalPosition: defaultVerticalPosition,
            horizontalPosition: defaultHorizontalPosition,
            mainTextColor: defaultColor,
            subTextColor: defaultColor,
            mainText: defaultMainText,
            subText: defaultSubText
          }
        };
      });
    }
  }, [title, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "ChartTitleSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("ChartTitleSelector.titleOptions.label", "Title options")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("ChartTitleSelector.showTitle.label", "Show title"),
    "data-testid": "ChartTitleSelector.showTitle.switch",
    checked: title == null ? void 0 : title.show,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.show",
          value: el.props.title.show = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    placeholder: translate("ChartTitleSelector.title.label", "title"),
    "data-testid": "ChartTitleSelector.mainText.input",
    value: title == null ? void 0 : title.mainText,
    style: {
      width: "200px"
    },
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.mainText",
          value: el.props.title.mainText = e.target.value
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    placeholder: translate("ChartTitleSelector.subText.label", "sub title"),
    "data-testid": "ChartTitleSelector.subText.input",
    value: title == null ? void 0 : title.subText,
    style: {
      marginTop: "5px",
      width: "200px"
    },
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.subText",
          value: el.props.title.subText = e.target.value
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ChartTitleSelector.fontSize.label", "Font size"),
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("ChartTitleSelector.titleFontSize.tooltip", "Title font size"),
    position: _core.Position.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "ChartTitleSelector.titleFontSize.input",
    min: 0,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.mainFontSize",
          value: el.props.title.mainFontSize = value
        };
      });
    },
    value: (title == null ? void 0 : title.mainFontSize) || defaultMainFontSize
  })), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("ChartTitleSelector.subTitleFontSize.tooltip", "Sub title font size"),
    position: _core.Position.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "ChartTitleSelector.subTitleFontSize.input",
    min: 0,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.subFontSize",
          value: el.props.title.subFontSize = value
        };
      });
    },
    value: (title == null ? void 0 : title.subFontSize) || defaultSubFontSize
  }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ChartTitleSelector.horizontalPosition.label", "Horizontal position")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "ChartTitleSelector.horizontalPosition.selector",
    items: ["top", "middle", "bottom"],
    selected: (title == null ? void 0 : title.horizontalPosition) != null ? [title.horizontalPosition] : [defaultHorizontalPosition],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.horizontalPosition",
          value: el.props.title.horizontalPosition = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ChartTitleSelector.verticalPosition.label", "Vertical position")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "ChartTitleSelector.verticalPosition.selector",
    items: ["left", "center", "right"],
    selected: (title == null ? void 0 : title.verticalPosition) != null ? [title.verticalPosition] : [defaultVerticalPosition],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref2) {
      var selected = _ref2[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.verticalPosition",
          value: el.props.title.verticalPosition = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ChartTitleSelector.titleColors.label", "Title colors")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("ChartTitleSelector.titleColor.tooltip", "Title color"),
    position: _core.Position.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
    "data-testid": "ChartTitleSelector.mainTextColor.picker",
    style: {
      width: "45px"
    },
    value: (title == null ? void 0 : title.mainTextColor) || defaultColor,
    onChange: function onChange(color) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.mainTextColor",
          value: el.props.title.mainTextColor = color
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("ChartTitleSelector.subTitleColor.tooltip", "Sub title color"),
    position: _core.Position.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
    "data-testid": "ChartTitleSelector.subTitleColor.picker",
    style: {
      width: "45px"
    },
    value: (title == null ? void 0 : title.subTextColor) || defaultColor,
    onChange: function onChange(color) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.title.subTextColor",
          value: el.props.title.subTextColor = color
        };
      });
    }
  })))));
};